import React from 'react'
import { Typography } from 'antd'
import logo from './../../../Assets/img/logo-no-background.png'
import primersoftLogo from './../../../Assets/img/primersoft/primersoft-logo.svg'
import { useTheme, useThemeColors } from '../../ThemeContext'
import { useBranding } from '../../branding/useBranding'

const { Text } = Typography

type OrganizationLogoProps = React.ImgHTMLAttributes<HTMLImageElement>

function OrganizationLogo({ style, ...props }: OrganizationLogoProps) {
	const { theme } = useTheme()
	const { primary } = useThemeColors()
	const isPrimersoft = theme === 'primersoft'
	const { brandingLogoUrl, organizationDisplayName } = useBranding()
	const themeFallback = isPrimersoft ? primersoftLogo : logo
	const resolvedSrc = brandingLogoUrl || themeFallback

	if (isPrimersoft) {
		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					textAlign: 'center',
				}}
			>
				<img
					src={resolvedSrc}
					alt='Branding logo'
					onError={(event) => {
						event.currentTarget.onerror = null
						event.currentTarget.src = themeFallback
					}}
					style={{
						width: '160px',
						height: 'auto',
						objectFit: 'contain',
						...style,
					}}
					{...props}
				/>
			</div>
		)
	}

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
			}}
		>
			<img
				src={resolvedSrc}
				alt='Branding logo'
				onError={(event) => {
					event.currentTarget.onerror = null
					event.currentTarget.src = themeFallback
				}}
				style={{
					width: '100px',
					height: '100px',
					borderRadius: '50%',
					objectFit: 'cover',
					backgroundColor: '#fff',
					...style,
				}}
				{...props}
			/>

			<Text
				style={{
					fontFamily: 'Times New Roman',
					fontSize: '22px',
					fontWeight: 'bold',
					color: primary,
					marginTop: '10px',
				}}
			>
				{organizationDisplayName}
			</Text>
		</div>
	)
}

export default OrganizationLogo
